import { useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import SearchIcon from '@mui/icons-material/Search';
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  Collapse,
} from '@mui/material';

const DefaultColumnFilter = ({ cell, debounce, resetPage }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const location = useLocation();

  const {
    isShowFilter,
    column: { id, filterValue, setFilter, filterInputType = 'text' },
  } = cell;

  const [value, setValue] = useState(filterValue);

  const onDebouncedChange = debounce(rawValue => {
    if (filterInputType === 'number') {
      if (rawValue === '') {
        // Сброс фильтра
        setFilter(undefined);
        searchParams.delete(id);
      } else {
        // Проверка валидности
        const isValid = /^\d+(\.\d*)?$/.test(rawValue);

        if (!isValid) {
          // Не меняем searchParams → запрос не уйдёт
          return;
        }

        // Устанавливаем валидное число
        setFilter(rawValue);
        searchParams.set(id, rawValue);
      }
    } else {
      // Обычное текстовое поле
      if (!rawValue) {
        setFilter(undefined);
        searchParams.delete(id);
      } else {
        setFilter(rawValue);
        searchParams.set(id, rawValue);
      }
    }

    setSearchParams(searchParams, { ...location });
    resetPage();
  }, 300);

  const handleFilterChange = e => {
    let inputValue = e.target.value;

    if (filterInputType === 'number') {
      // Заменяем , на .
      inputValue = inputValue.replace(',', '.');

      // разрешаем только цифры и одну точку
      const validNumberRegex = /^\d*\.?\d*$/;

      // если не пусто и невалидно — не обновляем
      if (inputValue !== '' && !validNumberRegex.test(inputValue)) {
        return;
      }
    }

    setValue(inputValue);
    onDebouncedChange(inputValue);
  };

  return (
    <Collapse id={id} in={isShowFilter} timeout="auto">
      <FormControl variant="outlined">
        <OutlinedInput
          id={id}
          name={id}
          className="column-filter"
          value={value || ''}
          endAdornment={
            <InputAdornment position="end">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          }
          inputProps={{
            'aria-label': 'weight',
          }}
          onChange={handleFilterChange}
          title=""
        />
      </FormControl>
    </Collapse>
  );
};

DefaultColumnFilter.propTypes = {
  cell: PropTypes.object.isRequired,
  debounce: PropTypes.func.isRequired,
  resetPage: PropTypes.func.isRequired,
};

export default DefaultColumnFilter;
